<template>
  <div class="payv2">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">代買幫付款</a>
      </nav>

      <!--  /////////////////////////////// -->
      <!-- <div class="title pt-3">付款方式</div> -->
      <div class="card">
        <div class="card-body">
          <div>
            <b>商品價格資訊</b>
          </div>
          <div>訂單編號:{{ orderInfo.key }}</div>
          <div>商品價格:{{ Math.ceil(orderInfo.prod_price) }}台幣</div>
          <div>預估國際運費:{{ orderInfo.freight_price }}台幣</div>
          <!-- <div>發票手續費:{{Math.ceil(orderInfo.invoice_price)}}</div> -->
          <br />
          <div style="font-size: 23px">
            <b>總共金額:{{ orderInfo.total }}台幣</b>
          </div>
        </div>
      </div>
      <br />
      <div class="card">
        <div class="card-body">
          <div style="float: left; display: block">
            <b>選擇付款銀行:</b>
          </div>
          <b-form-select
            v-model="atmPaymentSelected"
            :options="atmPaymentOptions"
          ></b-form-select>
        </div>
      </div>

      <div v-if="!orderInfo.paymentv_account">
        <br />
        <div v-if="orderInfo.status == 1">
          <button class="btn btn-danger btn-lg btn-block" @click="submit()">
            建立付款方式
          </button>
        </div>
        <div v-else>
          <h5>訂單已經過期!</h5>
        </div>
      </div>
      <div v-else>
        <br />
        <div class="card">
          <div class="card-body">
            <h5 id="bankDiv">繳費資訊</h5>
            <!-- <div>繳費期限:{{orderInfo.expire_date}}</div> -->
            <div>繳費期限:今日</div>
            <!-- <div>交易編號:{{orderInfo.payment_id}}</div> -->
            <div>繳費銀行代碼:{{ orderInfo.payment_bank_code }}</div>
            <div>繳費虛擬帳號:{{ orderInfo.paymentv_account }}</div>
            <br />
            <button
              class="btn btn-info btn-lg btn-block"
              v-clipboard:copy="orderInfo.paymentv_account"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              複製繳費虛擬帳號
            </button>
            <br />
          </div>
        </div>
      </div>

      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'payv2',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      webhookApiUrl: process.env.VUE_APP_WEBHOOK_API_URL,
      displayViews: null,
      isLoading: true,
      checkMobile: isMobile ? '1' : '0',
      orderid: null,
      orderInfo: {},
      atmPaymentSelected: null,
      atmPaymentOptions: [
        {
          value: null,
          text: '請選擇付款銀行',
        },
        //   {
        //     value: "TAISHIN",
        //     text: "台新"
        //   },
        //   {
        //     value: "ESUN",
        //     text: "玉山"
        //   },
        {
          value: 'BOT',
          text: '台灣銀行',
        },
        // {
        //   value: "FUBON",
        //   text: "台北富邦"
        // },
        {
          value: 'CHINATRUST',
          text: '中國信託',
        },
        //   {
        //     value: "FIRST",
        //     text: "第一銀行"
        //   },
        //   {
        //     value: "LAND",
        //     text: "土地銀行"
        //   },
        {
          value: 'CATHAY',
          text: '國泰世華銀行',
        },
        //   {
        //     value: "TACHONG",
        //     text: "大眾銀行"
        //   }
      ],
    }
  },
  methods: {
    onCopy: function () {
      const vm = this
      vm.$toast.open({
        message: '已幫您複製繳費虛擬帳號!',
        type: 'success',
      })
    },
    onError: function () {
      const vm = this
      vm.$toast.open({
        message: '複製失敗!',
        type: 'success',
      })
    },
    sendBidFbMessageConsumer: function (userId, order) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
          tempType: 'pay_atm',
          orderId: order.key,
          paymentId: order.payment_id,
          paymentBankCode: order.payment_bank_code,
          paymentvAccount: order.paymentv_account,
          price: order.price,
        }
        await axios
          .post(vm.webhookApiUrl + 'SendMsgButtonTemplate', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            if (data.result == 'ok') {
              vm.$toast.open({
                message: '發送訊息!',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '發送訊息失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    queryOrderByOrderId: function (order, sendmessage) {
      const vm = this

      if (order != null) {
        ;(async function post() {
          let formData = {
            orderId: order,
          }
          await axios
            .post(vm.apiUrl + 'QueryOrderByOrderId', formData, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            })
            .then(function (response) {
              var data = response.data
              vm.orderInfo = data

              vm.checkAccountExist(data.user_id)

              if (sendmessage) {
                //   var div = document.getElementById('bankDiv');
                //   div.scrollTop = div.scrollHeight;

                if (vm.orderInfo.paymentv_account != undefined) {
                  vm.sendBidFbMessageConsumer(localStorage.userId, {
                    key: vm.orderInfo.key,
                    expire_date: vm.orderInfo.expire_date,
                    payment_id: vm.orderInfo.payment_id,
                    payment_bank_code: vm.orderInfo.payment_bank_code,
                    paymentv_account: vm.orderInfo.paymentv_account,
                    total: vm.orderInfo.total,
                  })
                } else {
                  vm.$toast.open({
                    message: '訂單錯誤，請再申請其他家銀行試試，或聯絡客服',
                    type: 'error',
                  })
                }
              }
              vm.isLoading = false
            })
            .catch(function (error) {
              // console.log(error);
              vm.$toast.open({
                message: '此訂單有誤: ' + error,
                type: 'error',
              })
            })
        })()
      }
    },
    submit: function () {
      const vm = this

      if (vm.atmPaymentSelected != null) {
        vm.isLoading = true
        ;(async function post() {
          vm.$toast.open({
            message: '送出訂單中!!',
            type: 'success',
          })

          let formData = {
            orderId: vm.orderInfo.key,
            totalAmount: parseInt(vm.orderInfo.total),
            chooseSubPayment: vm.atmPaymentSelected,
          }
          await axios
            .post(vm.apiUrl + 'PayATM', formData, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            })
            .then(function () {
              // var data = response.data;
              vm.$toast.open({
                message: '確認建立訂單中~ 請稍候2秒鐘...',
                type: 'success',
              })
              ;(async function post() {
                await vm.queryOrderByOrderId(vm.orderInfo.key, true)
              })()
              // vm.isLoading = false;
            })
            .catch(function (error) {
              // console.log(error);
              vm.$toast.open({
                message: '此訂單有誤: ' + error,
                type: 'error',
              })
            })
        })()
      } else {
        vm.$toast.open({
          message: '請選擇付款方式',
          type: 'error',
        })
      }
    },
    checkAccountExist: function (userId) {
      const vm = this
      ;(async function post() {
        let formData = {
          userId: userId,
          isValid: 1,
        }
        await axios
          .post(vm.apiUrl + 'QueryProfile', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            if (data.length != 0) {
              // test
            } else {
              vm.$router.push('identityverificationv2?accountNotExist=1')
            }
          })
          .catch(function () {
            vm.$router.push('identityverificationv2?accountNotExist=1')
          })
      })()
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = true
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    vm.orderid = decodeURI(vm.$route.query.orderId)
    vm.queryOrderByOrderId(vm.orderid, false)
  },
}
</script>
